import React from 'react';
import InfoTooltip from './compat/InfoTooltip';
import PropTypes from 'prop-types';
import './objectRepeat.css';

import tick from '../../image/Icons/tick.svg';
import arrowForward from '../../image/Icons/arrow-forward.svg';

/**
 * ObjectRepeat
 *
 * @author  Miguel
 * @param   {Object}      props.industryKey          Industry Key.
 * @param   {Function}    props.onSelectPackage      React onSelectPackage.
 * @param   {Object}      props.packages             Product Config Packages.
 * @param   {String}      props.product              Product Name as String.
 * @returns {JSX.Element}                                   The component markup.
 */

const ObjectRepeat = ({ industryKey, onSelectPackage, packages, product }) => {
  const allPackages = packages || {};
  const productPackages = Object.keys(allPackages).map(function (singlePackage) {
    let item = allPackages[singlePackage];

    let classNames = require('classnames');
    let packageBtnClass = classNames({
      'btn package-btn btn-width-190': product !== 'commercial',
      'btn package-btn ': product === 'commercial'
    });
    const packageColumn = singlePackage == 'cordell_estimator_platinum_lite' ? 'col-xs-3 col-xs-offset-4' : 'col-xs-3'
    return (
      <div
        className={`${packageColumn} margin-top-20 package-box-container`}
        id={item.key}
        key={item.key}>
        {item.popular && (
          <div className='text-center'>
            <span className='popular-tag'>
              <i className='fa fa-star' aria-hidden='true'></i>
              <span> Popular</span>
            </span>
          </div>
        )}
        {item.starburst && (
          <div className='text-center'>
            <span className='popular-tag'>
              <i className='fa fa-star' aria-hidden='true'></i>
              <span> 20% Off</span>
            </span>
          </div>
        )}
        <p className='no-margin package-title'>{item.title}</p>
        {item.blurb && (
          <p className='packages-panel-body body'>
            <span className='white-space'>{item.blurb}</span>
          </p>
        )}
        {item.description && (
          <p
          className='packages-panel-body commercial-panel-body body'>
            <span className='white-space'>{item.description}</span>
          </p>
        )}
        {item.short_description && (
          <p
            className={
              product === 'CordellEstimatorNZ'
                ? 'package-blurb packages-panel-body cordell-panel-body body'
                : 'package-blurb packages-panel-body body'
            }
          >
            <span className='white-space'>{item.short_description}</span>
          </p>
        )}
        {item.dollars > 0 && (
          <p style={{maxWidth: '200px', margin: '10px 0px'}}>
            <span className='heading2'>
              <b style={{fontWeight: 700, fontSize: "30px", lineHeight: "32px"}}>${item.dollars}.{item.cents < 1 ? '00' : item.cents}</b>
            </span>
            {item.key !== 'one_month' && <span style={{lineHeight: "15px", fontSize: "14px", fontWeight: 400}}>/MTH</span>}
          </p>
        )}
        {item.dollars === 0 && (
          <p className='margin-top-neg-5'>
            <span className='package-selection-h4'>FREE</span>
          </p>
        )}
        <p className='sub-text footnote-text' style={{color: "#1e1405", fontSize: "10px", opacity: 0.6, margin: 0}}>{item.sub_text_1}</p>
        <p className='sub-text footnote-text' style={{color: "#1e1405", fontSize: "10px", opacity: 0.6, margin: 0}}>{item.sub_text_2}</p>
        <button
          type='button'
          id={`btn_${item.key}`}
          className={`${packageBtnClass} btn-arrow-move`}
          onClick={() => {
            onSelectPackage(industryKey, item.key);
          }}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            width: '100%',
            padding: '12px 24px',
          }}
        >
          {product === 'commercial' ? 'Customise Package' : 'Select Package'}
          <img src={arrowForward} alt='>' className='arrow-forward'/>
        </button>
        <hr/>
        <div className="features-list">
          {item.features.display?.map((feature, featureKey) => {
            if (feature) {
                  return (
                <div className="features-container body" key={featureKey}>
                  <div>
                    <img src={tick} alt='yes' className='margin-right-5 tick-margin' />
                  </div>
                  <div className="column title-column" style={{maxWidth: "82%"}}>
                    {feature.title}
                  </div>
                  <div className="column text-right">
                  {feature.description &&
                    <InfoTooltip text={feature.description}>
                      <span style={{
                        alignItems: "center",
                        border: "1px solid #79848b",
                        borderRadius: "50%",
                        cursor: "pointer",
                        display: "flex",
                        fontFamily: "TWK Everett, sans-serif",
                        fontSize: "11px",
                        height: "15px",
                        justifyContent: "center",
                        marginTop: "5px",
                        width: "15px"
                      }}>
                        i
                      </span>
                      </InfoTooltip>
                    }
                  </div>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  });
  return (
    <React.Fragment>
      <div className={product === 'CordellEstimatorNZ' ? 'd-none' : 'col-xs-3'}></div>
      {productPackages}
    </React.Fragment>
  );
};

ObjectRepeat.propTypes = {
  industryKey: PropTypes.object,
  onSelectPackage: PropTypes.func.isRequired,
  packages: PropTypes.object.isRequired,
  product: PropTypes.string.isRequired
};

export default ObjectRepeat;
